import { Box, Heading, Text } from "@vinomofo/components";

import React from "react";
import { TimerDisplay } from "../components/inline-countdown-timer/TimerDisplay";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_EventCountdown";

const create = (data: { title: string; startDate: string }): JSX.Element => {
  const { startDate } = data;
  if (!startDate) {
    return <></>;
  }

  const targetDate = dayjs(startDate);

  const calculateTimeLeft = () => {
    const now = dayjs();
    const end = dayjs(targetDate);
    const diff = end.diff(now);

    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, diff };

    const dur = dayjs.duration(diff);
    return {
      days: Math.floor(dur.asDays()),
      hours: dur.hours(),
      minutes: dur.minutes(),
      seconds: dur.seconds(),
      diff,
    };
  };

  const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft());

  React.useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Cleanup on unmount
    return () => clearInterval(timer);
  }, [targetDate]);

  const timeArray = [
    timeLeft.days,
    timeLeft.hours,
    timeLeft.minutes,
    timeLeft.seconds,
  ];

  return (
    <Box
      justifyContent={"center"}
      display="flex"
      alignContent={"center"}
      paddingTop={[250, 500, 750]}
      paddingBottom={[20, 80, 160]}
      gridGap={[20]}
    >
      {timeLeft.diff > 0 ? (
        <TimerDisplay dateTime={startDate} isExpandedDisplay={true} />
      ) : (
        <Box
          justifyContent={"center"}
          display="flex"
          flexDirection="column"
          alignContent={"center"}
          paddingTop={[10]}
          paddingBottom={[10]}
        >
          <Heading
            fontFamily="TIMMONSNY"
            color="white"
            textAlign="center"
            fontWeight={100}
            fontSize={100}
            letterSpacing={"normal"}
          >
            EVENT ENDED!
          </Heading>
        </Box>
      )}
    </Box>
  );

  // TO BE REMOVE
  return (
    <Box
      justifyContent={"center"}
      display="flex"
      alignContent={"center"}
      paddingTop={[290, 500, 750]}
      paddingBottom={[0, 40, 60]}
      gridGap={[20]}
    >
      {timeLeft.diff > 0 ? (
        timeArray.map((time, index) => (
          <Box
            key={index}
            justifyContent={"center"}
            display="flex"
            flexDirection="column"
            alignContent={"center"}
            paddingTop={[10]}
            paddingBottom={[10]}
          >
            <Heading
              fontSize={[90, 150, 200]}
              fontFamily="TIMMONSNY"
              color="white"
              textAlign="center"
              fontWeight={100}
              lineHeight={0.6}
            >
              {time.toString().padStart(2, "0")}
            </Heading>

            <Text
              fontSize={["10px", "15px", "15px"]}
              fontFamily="DM Sans, sans-serif"
              color="white"
              textAlign="center"
            >
              {["DAYS", "HRS", "MINS", "SECS"][index]}
            </Text>
          </Box>
        ))
      ) : (
        <Box
          justifyContent={"center"}
          display="flex"
          flexDirection="column"
          alignContent={"center"}
          paddingTop={[10]}
          paddingBottom={[10]}
        >
          <Heading
            fontSize={[90, 150, 170]}
            fontFamily="TIMMONSNY"
            color="white"
            textAlign="center"
            fontWeight={100}
          >
            EVENT ENDED!
          </Heading>
        </Box>
      )}
    </Box>
  );
};

export default { test, create };
